module.exports = __webpack_public_path__ + "static/img/product03.4f6f3b16.png";